import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const SpaceUnit = z.enum(["Pixels", "Rem", "Percent"]);

export const SpaceValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const SpaceTokenData = tokenAliasOrValue(SpaceValue);

export type SpaceUnit = z.infer<typeof SpaceUnit>;
export type SpaceValue = z.infer<typeof SpaceValue>;
export type SpaceTokenData = z.infer<typeof SpaceTokenData>;
